import {gql} from 'apollo-boost';

export const SUBMIT_DISCOVERY_SOURCE = gql`
  mutation SubmitDiscoverySource($data: SubmitDiscoverySourceInput!) {
    submitDiscoverySource(data: $data) {
      id
      discoverySource
      discoverySourceOther
    }
  }
`;
